import { Type } from "../../../harmony/core";
import { cloneWith } from "../services/clonable";

// TODO: Remove all usage of this function. Replace with forms, DTOs or whatever
// is appropriate. This is a huge hack to be able to remove
// `SerializableObject`.
/** @deprecated */
export const unsafeCreatePartial = <T extends object>(
  type: Type<T>,
  data: Partial<T>,
): T => cloneWith(new type(), data);
